import React from 'react'
import { font } from './constants'

function SectionDivider({ label, variant = 'light' }) {
  const isLight = variant === 'light'
  const line = isLight ? 'rgba(0,0,0,0.08)' : 'rgba(255,255,255,0.06)'
  const textColor = isLight ? '#6b6b6b' : '#6b7a90'
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '28px 0 20px' }}>
      <div style={{ height: 1, flex: 1, background: line }} />
      <span style={{ fontSize: 12, color: textColor, textTransform: 'uppercase', letterSpacing: 1.5, fontFamily: font, fontWeight: 600 }}>
        {label}
      </span>
      <div style={{ height: 1, flex: 1, background: line }} />
    </div>
  )
}

export default SectionDivider
